import {
  Page,
  Text,
  View,
  Document,
  StyleSheet,
  Image,
  Font,
} from "@react-pdf/renderer";
import ArabicRegular from "../../assets/ArabicFont/IBMPlexSansArabic-Regular.ttf";
import ArabicBold from "../../assets/ArabicFont/IBMPlexSansArabic-Bold.ttf";

Font.register({
  family: "Arabic",
  src: ArabicRegular,
});
Font.register({
  family: "ArabicBold",
  src: ArabicBold,
});

export const styles = StyleSheet.create({
  flex: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
  },
  flexRowReverse: {
    flexDirection: "row-reverse",
  },
  flexWrap: {
    flexWrap: "wrap",
  },

  underline: {
    textDecoration: "underline",
  },
  bold: {
    fontFamily: "Helvetica-Bold",
  },
  arabicBold: {
    fontFamily: "ArabicBold",
    textAlign: "right",
    direction: "rtl",
    textAlign: "left",
  },
  arabic: {
    fontFamily: "Arabic",
    flexDirection: "row",
    textAlign: "right",
    writingMode: "horizontal-tb",
    direction: "rtl",
    fontSize: "9px",
  },
});
